export const GET_SCRIBE_FOR_PLAYBACK_ERROR = 'GET_SCRIBE_FOR_PLAYBACK_ERROR';
export const GET_SCRIBE_FOR_PLAYBACK_SUCCESS = 'GET_SCRIBE_FOR_PLAYBACK_SUCCESS';
export const GET_SCRIBE_FOR_RENDER = 'GET_SCRIBE_FOR_RENDER';
export const SET_MUTED = 'SET_MUTED';
export const PLAY_FROM_EDITOR = 'PLAY_FROM_EDITOR';
export const PLAYBACK_IS_READY = 'PLAYBACK_IS_READY';
export const START_PLAYBACK = 'START_PLAYBACK';
export const STOP_PLAYBACK = 'STOP_PLAYBACK';

export const getScribeForPlaybackError = error => ({
  type: GET_SCRIBE_FOR_PLAYBACK_ERROR,
  error
});

export const getScribeForPlaybackSuccess = scribeData => ({
  type: GET_SCRIBE_FOR_PLAYBACK_SUCCESS,
  scribeData
});

export const getScribeForRender = scribeId => ({
  type: GET_SCRIBE_FOR_RENDER,
  scribeId
});

export const setMuted = muted => ({
  type: SET_MUTED,
  muted
});

export const playFromEditor = ({
  scribeId,
  startingElementId = null,
  autoPlay = true,
  isRecordingAudio = false,
  playAudio = true
}) => ({
  type: PLAY_FROM_EDITOR,
  scribeId,
  startingElementId,
  autoPlay,
  isRecordingAudio,
  playAudio
});

export const playbackIsReady = () => ({
  type: PLAYBACK_IS_READY
});

export const startPlayback = () => ({
  type: START_PLAYBACK
});

export const stopPlayback = () => ({
  type: STOP_PLAYBACK
});
